const defaultData = {
  state: 0,
  title: 'Sex Machine',
  buttonText: 'Show the result, which doesn’t matter',
  fieldGroups: [
    {
      name: null,
      fields: [
        {
          name: 'age',
          label: 'How old are you?',
          type: 'text',
          validate (input) {
            const num = parseFloat(input)
            if (input === '') return { message: 'Please enter a value', blank: true }
            else if (isNaN(input)) return { message: 'Please enter a number', blank: false }
            else if (Math.floor(num) !== num) return { message: 'Please enter a whole number', blank: false }
            else if (num < 18) return { message: 'This interactive is meant to be used by readers 18 or older', blank: false }
            else return { message: 'valid', blank: false }
          },
          valid: { message: 'Please enter a value', blank: true }
        },
        {
          name: 'sex_frequency',
          label: 'About how often did you have sex during the last 12 months?',
          type: 'select',
          defaultOption: 'Choose from the list',
          options: [
            { text: 'Not at all', value: 0 },
            { text: 'Once or twice', value: 1 },
            { text: 'Once a month', value: 2 },
            { text: 'Two or three times a month', value: 3 },
            { text: 'Weekly', value: 4 },
            { text: 'Two or three times a week', value: 5 },
            { text: 'Four or more times a week', value: 6 }
          ],
          valid: { message: 'Please enter a value', blank: true }
        },
        {
          name: 'hasPartner',
          label: 'Was one of the partners your husband or wife or regular sexual partner?',
          type: 'radio',
          options: [
            { text: 'Yes', value: 1, checked: false },
            { text: 'No', value: 0, checked: false }
          ],
          validate (input) {
            return { message: 'valid', blank: false }
          },
          valid: { message: 'Please enter a value', blank: true }
        }
      ]
    }
  ],
  result: null,
  showMethodology: false,
  methodology: '<p>The data in this interactive comes from the General Social Survey (GSS), a biannual survey of Americans’ self-reported behaviors and beliefs. The GSS is nationally representative, meaning that the samples are designed to reflect the demographic composition of the country as a whole. The interactive combines the samples from every survey starting in 2000 and ending in 2014, minus respondents who don’t have a recorded age, didn’t say how often they had sex, or didn’t say whether they had a regular sexual partner. The resulting pool includes 15,595 people, of whom 11,052 had a regular sexual partner.</p><p>The age groups in the interactive are based on loose clusters in the data but ultimately arbitrary. They reflect the respondents’ ages at the time they took the survey, not their ages at the time the interactive was published. The questions and response options in the interactive are worded the same way they are on the GSS, with a couple formatting changes.</p>'
}

defaultData.fieldGroups[0].fields[1].validate = function (input) {
  const partnerField = defaultData.fieldGroups[0].fields[2]
  if (parseInt(input) === 0) {
    partnerField.options[2] = { text: 'N/A', checked: true }
    partnerField.options.forEach((option) => { option.disabled = true })
    partnerField.value = 0
    partnerField.valid.message = 'valid'
    partnerField.wasDisabled = true
  } else if (partnerField.wasDisabled) {
    partnerField.options = partnerField.options.slice(0, 2)
    partnerField.options.forEach((option) => { option.disabled = false })
    partnerField.options.forEach((option) => { option.checked = false })
    partnerField.valid = { message: 'Please enter a value', blank: true }
    partnerField.wasDisabled = false
    delete partnerField.value
  }
  return { message: 'valid', blank: false }
}

export default defaultData



// WEBPACK FOOTER //
// ./assets/Data.js